<script >
import {Message} from "element-ui";
import {findByEquipmentId, saveOrUpdate} from "@/api/concat";

export default {
  name: 'ContactDrawer',
  data() {
    return {
      equipmentId : null,
      visible: false,
      contact: {},
      contactList: [],
      contactListLoading: false,
      submitLoading: false,
      dialogVisible : false,
    }
  },
  methods: {
    open(id) {
      if (!id){
        Message.error("参数丢失");
        return
      }
      this.equipmentId = id
      this.fetchContactList(id)
      this.visible = true


    },
    async fetchContactList(id) {
      this.contactListLoading = true
      findByEquipmentId({equipmentId : id}).then(res => {
        this.contactList = res.result
      })
      .catch(err => Message.error( err.message))
      .finally(() => this.contactListLoading = false)

    },

    onSubmit(){
      console.log('提交',this.contact)
      this.submitLoading = true
      let param = this.contact
      if (!this.contact.id){
        // 新增
        param.equipmentId = this.equipmentId
      }
      saveOrUpdate(param).then(res => {
        if (res && res.code === '0000'){
          Message.success(res.message)
          this.fetchContactList(this.equipmentId)
        }

      }).finally(() => {
        this.submitLoading = false;
        this.dialogVisible = false
      })
    },

    editContact(item){
      this.contact = {
        ...item,
        sort: String(item.sort)
      }
      this.dialogVisible = true
    },
  }
}
</script>

<template>
  <div>
    <el-drawer
        title="联系人"
        :visible.sync="visible"
        direction="rtl"
        :with-header="false"
    >
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>联系人列表</span>
          <el-button style="float: right; padding: 3px 0" type="text" @click="() => {
            this.contact =  {};
             this.dialogVisible = true
          }">新增</el-button>
        </div>

        <!--联系人table-->
        <el-table :data="contactList" border stripe highlight-current-row >
          <el-table-column prop="contactName" label="名称" width="160" >
            <template slot-scope="scope">
              <div style="display: flex ; gap: 4px; align-items: center">
                <span>{{scope.row.contactName}}</span>
                <el-tag v-if="scope.row.sort === 0" type="success">主要</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="professionRemark" label="职称" />
          <el-table-column prop="contactPhone" label="手机号" width="120" />

          <el-table-column label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-row gutter="2">
                <el-button size="mini" type="text" @click="() => editContact(scope.row)">编辑</el-button>
                <el-button size="mini" type="text" >删除</el-button>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

    </el-drawer>

    <el-dialog :title=" contact.id ? '编辑联系人' : '新增联系人'" :visible.sync="dialogVisible" width="500px">
      <el-form ref="contact" :model="contact" label-width="100px">
        <el-form-item label="联系人名称">
          <el-input v-model="contact.contactName" placeholder="请输入联系人名称" />
        </el-form-item>
        <el-form-item label="联系人职称">
        <el-input v-model="contact.professionRemark" placeholder="请输入联系人职称" />
        </el-form-item>
        <el-form-item label="联系人名称">
          <el-input v-model="contact.contactPhone" placeholder="请输入联系人手机号" />
        </el-form-item>
        <el-form-item label="是否主要">
          <el-radio-group v-model="contact.sort">
            <el-radio label="0" >主要</el-radio>
            <el-radio label="1" >普通联系人</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit" :loading="submitLoading">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>

</template>

<style scoped>

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}

.box-card {
  width: inherit;

}
</style>
